import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetcher, throwApiError } from '@commenda/utils';

import { adminManagedAgentsKeys } from './keys';
import type { IAdminManagedAgent, IUpdateManagedAgentParams } from './types';

export function useUpdateAdminManagedAgent() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      id,
      params,
    }: {
      id: string;
      params: IUpdateManagedAgentParams;
    }) => {
      const response = await fetcher(`admin/managed-agents/${id}`, {
        method: 'PATCH',
        body: params,
      });
      if (!response.ok)
        await throwApiError(response, 'Failed to update the managed agent');
      return ((await response.json()) as { managedAgent: IAdminManagedAgent })
        .managedAgent;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminManagedAgentsKeys.all });
    },
  });
}
